function Guernsey({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1303)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2927 0 14.5962 0.0465 13.9131 0.135438V13.9131H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7073 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2927 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7073 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131V13.9131Z" fill="#D80027"/>
  <path d="M20.5218 16.6954L21.5652 17.3911V14.6084L20.5218 15.3041H16.6956V11.478L17.3913 10.4346H14.6087L15.3044 11.478V15.3041H11.4783L10.4348 14.6084V17.3911L11.4783 16.6954H15.3044V20.5215L14.6087 21.5649H17.3913L16.6956 20.5215V16.6954H20.5218Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Guernsey;
